import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { DialogApprovalsEquipmentsApproveComponent } from './dialog-approvals-approve.component';

@NgModule({
    entryComponents: [
        DialogApprovalsEquipmentsApproveComponent
    ],
    declarations: [
        DialogApprovalsEquipmentsApproveComponent
    ],
    imports: [
        TranslateModule,

        FuseSharedModule,

        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatInputModule,
        MatSnackBarModule
    ],
    exports: [
        DialogApprovalsEquipmentsApproveComponent
    ]
})
export class DialogApprovalsEquipmentsApproveModule {
}
